/* Lirogo: preserve active Shopify filter query parameters while sorting. */
document.addEventListener('change', function (event) {
  var input = event.target.closest('[data-lirogo-sort-option]');
  if (!input) return;
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', input.value);
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});
